import { getEffectiveTrackingQueryParams } from "../trackingPersistence/trackingPersistence";

export const AGELESS_TRACKING_HEADER_PREFIX = "x-ageless-tracking-";

const normalizeTrackingHeaderKey = (key: string): string =>
  key
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, "-");

export const getTrackingHeaders = (): Headers => {
  const headers = new Headers();
  const trackingParams = getEffectiveTrackingQueryParams();

  for (const [key, value] of trackingParams.entries()) {
    const normalizedTrackingKey = normalizeTrackingHeaderKey(key);
    if (!normalizedTrackingKey) {
      continue;
    }

    headers.set(`${AGELESS_TRACKING_HEADER_PREFIX}${normalizedTrackingKey}`, value);
  }

  return headers;
};
